import { HttpEventType } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
//import ImageEditor from 'tui-image-editor';
import { CacheService } from '../../cache/cache.service';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { MediaSource } from '../../models/datamodel/mediasource.model';
import { MessageBoxButtons } from '../../models/enums/messageboxbuttons.enum';
import { MessageBoxIcon } from '../../models/enums/messageboxicon.enum';
import { MessageBoxResult } from '../../models/enums/messageboxresult.enum';
import { MediaService } from '../../services/media.service';
import { IOptions } from '../controls/imageeditor/imageeditor.models';
import { MessageBoxHelper } from '../dialogs/messagebox/messagebox.dialog';

@Component({
    selector: 'evi-file-explorer',
    templateUrl: './fileexplorer.control.html',
    styleUrls: ['./fileexplorer.control.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileExplorerControl implements OnInit {

    //#region MediaSource
    MediaSourceIDValue;
    SearchValue: string;
    @Input()
    get MediaSourceID() {
        return this.MediaSourceIDValue;
    }
    set MediaSourceID(val) {
        this.MediaSourceIDValue = val;
        this.MediaSourceIDChange.emit(this.MediaSourceIDValue);
    }

    @Output() MediaSourceIDChange = new EventEmitter<any>();
    //#endregion

    //#region MediaSource
    SelectionValue;

    @Input()
    get Selection() {
        return this.SelectionValue;
    }
    set Selection(val) {
        this.SelectionValue = val;
        if (!val || (val && val.indexOf('.svg') > -1)) {
            this.Editable = false;
        } else {
            this.Editable = true;
        }
        this.SelectionChange.emit(this.SelectionValue);
    }

    @Output() SelectionChange = new EventEmitter<any>();
    //#endregion

    @Output() FileUploaded = new EventEmitter<any>();

    /**
     * Verwaltung statt Auswahl.
     *
     * Der Explorer wird im Designer als Auswahldialog benutzt (Bild-, SVG-,
     * Objekt-Control) und aus der Medienquellen-Pflege als Dateibrowser. Im
     * Verwaltungsmodus kommen Herunterladen und Mehrfach-Upload dazu, und Ordner
     * werden ueber DeleteFolder geloescht. Beides haengt am Recht
     * DataRight.MediaSource, das Designer-Benutzer nicht haben muessen -- deshalb
     * bleibt der Auswahlmodus bei seinem bisherigen Verhalten.
     */
    @Input() ManageMode = false;

    @Input()
    get FixedPath() {
        return this.Path;
    }
    set FixedPath(val) {
        if (Array.isArray(val)) {
            this.Path = val;
            this.HasFixedPath = true;
        } else {
            this.Path = ['./'];
            this.HasFixedPath = false;
        }
    }

    Items = [];
    originalItems=[];
    FolderName;
    Path = ['./'];
    HasFixedPath = false;
    MediaSource;
    FolderCreation = false;
    Uploading = false;
    UploadProgress = 0;
    Uploadindeterminate = false;
    UploadError = false;
    EditMode = false;
    Editable = true;
    EditorOptions: IOptions;
    Editor;//: ImageEditor;
    Loading = false;

    /** Sortierung der Kacheln; Ordner bleiben immer vorne. */
    SortField: 'Name' | 'Size' | 'Modified' = 'Name';
    SortAscending = true;
    /** Ausgangspunkt fuer die Bereichsauswahl mit Shift. */
    private anchorItem = null;
    private static readonly SortStorageKey = 'fileexplorer.sort';

    constructor(private mediaService: MediaService, private sanitizer: DomSanitizer, private iconRegistry: MatIconRegistry, private cdRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.restoreSort();
        CacheService.ReadMediaSource(this.MediaSourceID).then((data) => {
            this.MediaSource = data;
            this.Refresh();
        });
    }

    //#region Folder
    CreateFolder() {
        this.mediaService.CreateFolder(this.MediaSourceID, this.createPath() + this.FolderName).subscribe((result) => { this.Refresh(); });
        this.FolderCreation = false;
        this.FolderName = null;
    }

    OpenFolderCreation() {
        this.FolderCreation = true;
    }
    CancelFolderCreation() {
        this.FolderCreation = false;
    }
    //#endregion
    /**
     * Klick auf eine Kachel.
     *
     * Ohne Modifier wie bisher: Ordner oeffnen, Datei einzeln auswaehlen. Im
     * Verwaltungsmodus kommt die Mehrfachauswahl dazu -- Strg/Cmd schaltet einen
     * Eintrag um, Shift waehlt den Bereich ab dem zuletzt angeklickten. Dabei sind
     * auch Ordner auswaehlbar, damit sie mitgeloescht werden koennen.
     */
    ItemSelected(item, event?: MouseEvent) {
        const toggle = this.ManageMode && !!event && (event.ctrlKey || event.metaKey);
        const range = this.ManageMode && !!event && event.shiftKey;
        if ((toggle || range) && item.Name !== '..') {
            const from = this.Items.indexOf(this.anchorItem);
            if (range && from > -1) {
                const to = this.Items.indexOf(item);
                if (!toggle) {
                    this.Items.forEach(i => i.Selected = false);
                }
                for (let i = Math.min(from, to); i <= Math.max(from, to); i++) {
                    if (this.Items[i].Name !== '..') {
                        this.Items[i].Selected = true;
                    }
                }
            } else {
                item.Selected = !item.Selected;
                this.anchorItem = item;
            }
            this.syncSelection();
            return;
        }
        this.Items.forEach((i) => {
            i.Selected = false;
        });
        this.anchorItem = item.IsDir ? null : item;
        if (item.IsDir) {
            this.FolderSelected(item);
        } else {
            item.Selected = true;

            this.EditorOptions = {
                includeUI: {
                    loadImage: {
                        path: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                        name: 'Blank'
                    }
                },
                cssMaxWidth: 1000, // Component default value: 1000
                cssMaxHeight: 800  // Component default value: 800
            };

            this.Selection = this.createPath() + item.Name;
        }
    }

    /** Ausgewaehlte Eintraege im aktuellen Ordner, ohne den Eintrag '..'. */
    get SelectedItems() {
        return this.Items.filter(x => x.Selected && x.Name !== '..');
    }

    /**
     * Haelt Selection mit der Mehrfachauswahl in Einklang.
     *
     * Selection ist der Vertrag nach aussen (Auswahldialog, Download, Bildbearbeitung)
     * und steht nur fuer genau eine Datei. Bei mehreren Eintraegen oder einem Ordner
     * bleibt sie leer.
     */
    private syncSelection() {
        const selected = this.SelectedItems;
        this.Selection = selected.length === 1 && !selected[0].IsDir ? this.createPath() + selected[0].Name : null;
        this.cdRef.detectChanges();
    }

    SelectAll() {
        const all = this.Items.filter(x => x.Name !== '..');
        const select = all.some(x => !x.Selected);
        all.forEach(x => x.Selected = select);
        this.anchorItem = null;
        this.syncSelection();
    }

    //#region Sort
    SetSort(field: 'Name' | 'Size' | 'Modified') {
        if (this.SortField === field) {
            this.SortAscending = !this.SortAscending;
        } else {
            this.SortField = field;
            // Datum und Groesse will man meist absteigend: neueste bzw. groesste zuerst.
            this.SortAscending = field === 'Name';
        }
        try {
            localStorage.setItem(FileExplorerControl.SortStorageKey, JSON.stringify({ Field: this.SortField, Ascending: this.SortAscending }));
        } catch { }
        this.originalItems = this.sortItems(this.originalItems);
        this.Items = this.sortItems(this.Items);
        this.cdRef.detectChanges();
    }

    private restoreSort() {
        try {
            const stored = JSON.parse(localStorage.getItem(FileExplorerControl.SortStorageKey));
            if (stored && ['Name', 'Size', 'Modified'].indexOf(stored.Field) > -1) {
                this.SortField = stored.Field;
                this.SortAscending = stored.Ascending !== false;
            }
        } catch { }
    }

    private sortItems(items: any[]): any[] {
        const direction = this.SortAscending ? 1 : -1;
        const byName = (x, y) => x.Name.localeCompare(y.Name, undefined, { sensitivity: 'base', numeric: true });
        return [...items].sort((x, y) => {
            if (x.Name === '..') { return -1; }
            if (y.Name === '..') { return 1; }
            if (x.IsDir !== y.IsDir) { return x.IsDir ? -1 : 1; }
            let result = 0;
            if (this.SortField === 'Size') {
                result = (x.Size ?? 0) - (y.Size ?? 0);
            } else if (this.SortField === 'Modified') {
                // Ohne Datum (Ordner, Backends ohne Zeitstempel) ans Ende, unabhaengig von der Richtung.
                if (x.ModifiedTime === null || y.ModifiedTime === null) {
                    if (x.ModifiedTime !== y.ModifiedTime) {
                        return x.ModifiedTime === null ? 1 : -1;
                    }
                } else {
                    result = x.ModifiedTime - y.ModifiedTime;
                }
            }
            if (result === 0) {
                // Gleichstand und Ordner immer nach Name, damit die Reihenfolge stabil bleibt.
                return this.SortField === 'Name' ? direction * byName(x, y) : byName(x, y);
            }
            return direction * result;
        });
    }
    //#endregion
    EditorLoaded(instance) {
        this.Editor = instance;
        const url = MediaSource.GetURL(this.MediaSource, this.Selection);
        this.Editor.loadImageFromURL(url, this.Selection).then(result => {
            this.Editor['ui'].resizeEditor({
                imageSize: {
                    oldWidth: result.oldWidth,
                    oldHeight: result.oldHeight,
                    newWidth: result.newWidth,
                    newHeight: result.newHeight
                }
            });
        }).catch(err => {
            console.error('Something went wrong:', err);
        });

        this.Editor.loadImageFromURL(url);
    }
    Edit() {
        this.EditMode = true;
    }
    CancelEdit() {
        this.EditMode = false;
    }

    convertDataUrlToBlob(dataUrl): Blob {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new Blob([u8arr], { type: mime });
    }

    AcceptEdit() {
        this.EditMode = false;
        const file = new File([this.convertDataUrlToBlob(this.Editor.toDataURL())], this.Selection);
        this.UploadChanged(file);
    }
    Delete() {
        const selected = this.SelectedItems;
        if (this.ManageMode && (selected.length > 1 || (selected.length === 1 && selected[0].IsDir))) {
            this.DeleteSelected(selected);
            return;
        }
        if (this.Selection) {
            const text = new TranslateFormatText('@@Sind Sie sicher, dass Sie die Datei {0} loeschen moechten?');
            text.FormatParams.push(this.Selection);
            MessageBoxHelper.ShowDialog(text, new TranslateFormatText('@@Loeschen'),
                MessageBoxButtons.YesNo, MessageBoxIcon.Question).then(x => {
                    if (x === MessageBoxResult.Yes) {
                        this.mediaService.DeleteFile(this.MediaSourceID, this.SelectionValue).subscribe((result) => { this.Refresh(); });
                    }
                });
        } else {
            const path = this.createPath();
            if (!path) {
                // Ohne Auswahl loescht der Button den aktuellen Ordner. In der Wurzel waere
                // das ein Loeschen mit leerem Pfad -- also der ganzen Quelle. Nie.
                return;
            }
            const text = new TranslateFormatText('@@Sind Sie sicher, dass Sie den Ordner {0} loeschen moechten?');
            text.FormatParams.push(path);
            MessageBoxHelper.ShowDialog(text, new TranslateFormatText('@@Loeschen'),
                MessageBoxButtons.YesNo, MessageBoxIcon.Question).then(x => {
                    if (x === MessageBoxResult.Yes) {
                        const afterDelete = () => {
                            this.Path = this.Path.slice(0, this.Path.length - 1);
                            this.Refresh();
                        };
                        if (this.ManageMode) {
                            this.mediaService.DeleteFolder(this.MediaSourceID, path).subscribe(afterDelete);
                        } else {
                            this.mediaService.DeleteFile(this.MediaSourceID, path).subscribe(afterDelete);
                        }
                    }
                });
        }
    }

    /**
     * Loescht die Mehrfachauswahl in einer Anfrage.
     *
     * Ordner gehen dabei ueber DeleteFolder, also samt Inhalt -- die Rueckfrage
     * nennt das deshalb ausdruecklich. Was nicht geloescht werden konnte, wird
     * danach namentlich gemeldet.
     */
    private DeleteSelected(selected: any[]) {
        const path = this.createPath();
        const folders = selected.filter(x => x.IsDir).length;
        let text: TranslateFormatText;
        if (folders > 0) {
            text = new TranslateFormatText('@@Sind Sie sicher, dass Sie {0} Eintraege loeschen moechten? {1} davon sind Ordner, die samt Inhalt geloescht werden.');
            text.FormatParams.push(String(selected.length), String(folders));
        } else {
            text = new TranslateFormatText('@@Sind Sie sicher, dass Sie {0} Dateien loeschen moechten?');
            text.FormatParams.push(String(selected.length));
        }
        MessageBoxHelper.ShowDialog(text, new TranslateFormatText('@@Loeschen'),
            MessageBoxButtons.YesNo, MessageBoxIcon.Question).then(x => {
                if (x !== MessageBoxResult.Yes) {
                    return;
                }
                this.Loading = true;
                this.cdRef.detectChanges();
                const items = selected.map(item => ({ Name: path + item.Name, IsDir: !!item.IsDir }));
                this.mediaService.DeleteItems(this.MediaSourceID, items).subscribe(results => {
                    const failed = (results ?? []).filter(r => !r.Deleted);
                    this.Refresh();
                    if (failed.length > 0) {
                        const error = new TranslateFormatText('@@{0} Eintraege konnten nicht geloescht werden: {1}');
                        error.FormatParams.push(String(failed.length), failed.map(f => f.Name).join(', '));
                        MessageBoxHelper.ShowDialog(error, new TranslateFormatText('@@Loeschen'), MessageBoxButtons.Ok, MessageBoxIcon.Warning);
                    }
                }, () => {
                    this.Refresh();
                });
            });
    }

    /**
     * Laedt die ausgewaehlte Datei herunter.
     *
     * Der Blob kommt ueber HttpClient, damit die Anmeldung mitgeht; ein direkter
     * Link auf den Endpunkt waere ohne Token.
     */
    Download() {
        if (!this.Selection) {
            return;
        }
        const name = this.Selection;
        this.Loading = true;
        this.cdRef.detectChanges();
        this.mediaService.Download(this.MediaSourceID, name).subscribe(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = name.substring(name.lastIndexOf('/') + 1);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Verzoegert freigeben: im selben Durchlauf wie der Klick brechen manche
            // Browser den Download noch ab.
            setTimeout(() => URL.revokeObjectURL(url), 10000);
            this.Loading = false;
            this.cdRef.detectChanges();
        }, () => {
            this.Loading = false;
            this.cdRef.detectChanges();
        });
    }
    /**
     * Laedt die gewaehlten Dateien in den aktuellen Ordner.
     *
     * Im Verwaltungsmodus alle, im Auswahlmodus wie bisher nur die erste -- der
     * Auswahldialog meldet die hochgeladene Datei per FileUploaded an sein Control
     * zurueck, und das erwartet genau eine.
     * <p>
     * Alle Dateien gehen in einer Anfrage raus; UploadSpecific geht serverseitig
     * ohnehin ueber alle Form-Dateien. Der Ereignis-Switch laeuft deshalb einmal je
     * Ereignis, nicht einmal je Datei -- die fruehere Fassung hat ihn pro
     * Formularfeld wiederholt und damit mehrfach neu geladen.
     */
    Upload(event) {
        const input = event.target;
        const all: File[] = Array.from(input.files || []);
        if (all.length === 0) {
            return;
        }
        const files = this.ManageMode ? all : all.slice(0, 1);
        this.UploadError = false;
        const uploadData = new FormData();
        const path = this.createPath();
        files.forEach(file => uploadData.append(path + file.name, file, path + file.name));
        this.mediaService.UploadSpecific(this.MediaSourceID, uploadData).subscribe(e => {
            switch (e.type) {
                case HttpEventType.Sent:
                    this.Uploading = true;
                    break;
                case HttpEventType.UploadProgress:
                    this.UploadProgress = e.total ? Math.round(100 * e.loaded / e.total) : 0;
                    if (this.UploadProgress === 100) {
                        // Hochgeladen, der Server legt die Dateien aber noch ab.
                        this.Uploadindeterminate = true;
                        this.Uploading = false;
                        this.UploadProgress = 0;
                    }
                    break;
                case HttpEventType.Response:
                    if (!this.ManageMode) {
                        this.FileUploaded.emit(files[0].name);
                    }
                    this.Refresh();
                    break;
                // Response-Header und Download-Fortschritt sind keine Fehler; die frueher
                // hier gesetzte UploadError-Markierung kam genau daher.
            }
            this.cdRef.detectChanges();
        }, () => {
            this.Uploading = false;
            this.Uploadindeterminate = false;
            this.UploadError = true;
            this.cdRef.detectChanges();
        });
        // Sonst loest dieselbe Datei beim zweiten Mal kein change-Ereignis mehr aus.
        input.value = '';
    }
    UploadChanged(file) {
        this.UploadError = false;
        const uploadData = new FormData();
        const path = this.createPath();
        uploadData.append(path + file.name, file, path + file.name);
        this.mediaService.UploadSpecific(this.MediaSourceID, uploadData).subscribe(event => {
            uploadData.forEach((value) => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        this.Uploading = true;
                        break;
                    case HttpEventType.UploadProgress:
                        this.UploadProgress = Math.round(100 * event.loaded / event.total);
                        if (this.UploadProgress === 100) {
                            this.Uploadindeterminate = true;
                            this.Uploading = false;
                            this.UploadProgress = 0;
                        }
                        break;
                    case HttpEventType.Response:
                        this.Refresh();
                        break;
                    default:
                        this.UploadError = true;
                        break;
                }
            });
        });
    }
    Refresh() {
        this.Loading = true;
        this.Uploadindeterminate = false;
        this.ResetSelection();
        const path = this.createPath();
        this.mediaService.ListObjects(this.MediaSourceID, path).subscribe((result) => {
            if (path && !this.HasFixedPath) {
                this.Items = [{ Name: '..', IsDir: true }];
            } else {
                this.Items = [];
            }
            if (result) {
                const msURL = MediaSource.GetURL(this.MediaSource);
                result.forEach((item) => {
                    // Typ zuerst: davon haengt ab, ob ueberhaupt eine Vorschau geladen wird.
                    item.Type = item.IsDir ? '' : item.Name.substring(item.Name.lastIndexOf('.') + 1).toLowerCase();
                    item.IsImage = !item.IsDir && ['jpg', 'jpeg', 'bmp', 'png', 'gif', 'tiff', 'svg', 'webp'].indexOf(item.Type) > -1;
                    item.SizeText = item.IsDir ? '' : FileExplorerControl.FormatSize(item.Size);
                    item.ModifiedTime = item.Modified ? new Date(item.Modified).getTime() : null;
                    item.ModifiedText = item.ModifiedTime === null ? '' : new Date(item.ModifiedTime).toLocaleString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
                    if (!item.IsDir && this.MediaSource.Private) {
                        // Bei privaten Quellen kommt die Vorschau als komplette Datei in Base64.
                        // Das nur fuer Bilder -- frueher lief es fuer jede Datei, auch fuer
                        // PDFs und ZIPs, die danach bloss ein Dokumentsymbol zeigen. Ein Ordner
                        // mit ein paar hundert Dateien war damit praktisch nicht mehr offen.
                        if (item.IsImage) {
                            this.mediaService.LoadImage(this.MediaSource.SID, path + item.Name).subscribe((image) => {
                                item.URL = image;
                                this.cdRef.detectChanges();
                            });
                        }
                    } else {
                        item.URL = msURL + '/' + path + item.Name + '?a=' + Math.random();
                    }
                    this.Items.push(item);
                });
                // Ordner zuerst, darin nach der gewaehlten Sortierung. Die fruehere Bedingung
                // pruefte das Objekt statt IsDir und war damit immer wahr -- die Reihenfolge
                // war zufaellig.
                this.Items = this.sortItems(this.Items);
                this.originalItems = [...this.Items];
                if (this.SearchValue) {
                    this.searchFilter();
                }
            }
            this.Loading = false;
            this.cdRef.detectChanges();
        });
    }

    searchFilter()
    {
        if (this.SearchValue) {
            const toLower = this.SearchValue.toLowerCase();
            // Immer von der vollstaendigen Liste aus. Frueher wurde die schon gefilterte
            // weiter eingeschraenkt -- ein geloeschtes Zeichen brachte nichts zurueck.
            this.Items = this.originalItems.filter(x => x.Name === '..' || x.Name.toLowerCase().indexOf(toLower) > -1);
        } else {
            this.Items = [...this.originalItems];
        }
        this.cdRef.detectChanges();
    }

    /** Dateigroesse lesbar, mit deutschem Dezimalkomma. */
    static FormatSize(bytes: number): string {
        if (bytes === null || bytes === undefined || isNaN(bytes)) {
            return '';
        }
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let value = bytes;
        let unit = 0;
        while (value >= 1024 && unit < units.length - 1) {
            value /= 1024;
            unit++;
        }
        const digits = unit === 0 || value >= 100 ? 0 : 1;
        return value.toFixed(digits).replace('.', ',') + ' ' + units[unit];
    }

    FolderSelected(folder) {
        if (folder.Name === '..') {
            this.Path = this.Path.slice(0, this.Path.length - 1);
        } else {
            this.Path.push(folder.Name);
        }
        this.SearchValue="";
        this.Refresh();
    }
    /**
     * Der Ablagepfad des aktuellen Verzeichnisses, mit Schraegstrich am Ende.
     *
     * Vorher wurden die Abschnitte nur aneinandergehaengt, in der Annahme, dass Ordnernamen
     * ihren Schraegstrich aus der Liste mitbringen. Minio liefert ihn und haengt ihn sogar
     * selbst an -- GAFileShare nicht. Dort entstand aus dem Ordner 'archiv' und der Datei
     * 'datei.csv' der Name 'archivdatei.csv', und jeder Zugriff auf einen Unterordner ging ins
     * Leere: Loeschen meldete Fehler, Anlegen erzeugte 'archivneu' statt 'archiv/neu'.
     */
    createPath() {
        let path = '';
        this.Path.forEach((folder) => {
            if (folder !== './') {
                path += folder.endsWith('/') ? folder : folder + '/';
            }
        });
        return path;
    }
    PathSelected(index) {
        this.Path = this.Path.slice(0, index + 1);
        this.Refresh();
    }
    ResetSelection() {
        this.Items.forEach(i => i.Selected = false);
        this.anchorItem = null;
        this.Selection = null;
    }
}
